import React from "react";
import type { FC } from "react";

import { Button } from "../../../Button";

import type { VibeButtonProps } from "../../types";

const VIBE_MAIN_BUTTON_TEST_ID = "vibe-main-button-test-id";

export const VibeMainButton: FC<VibeButtonProps> = ({
    view = "primary",
    customColorsStyles,
    "data-tsid": tsid = VIBE_MAIN_BUTTON_TEST_ID,
    ...otherProps
}) => {
    const buttonProps = (() => {
        if (view !== "custom") {
            return {
                ...otherProps,
                view,
            };
        }

        return {
            ...otherProps,
            view,
            customColorsStyles: customColorsStyles!,
        };
    })();

    return <Button data-tsid={tsid} {...buttonProps} />;
};

VibeMainButton.displayName = "Vibe.MainButton";

export default VibeMainButton;
